export const theme = {
    primary: "#033594",
    light: "#E7F3FF",
    primaryDark: "#022b6b",
    contrast: "#ffffff",
    accent: "#ffcc00",
    footerBg: "#022b6b",
    navHover: "#0b4db7",
    buttonBg: "#ff3e77",
    buttonHover: "#e22f65",
};
